import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../components/Modal';
import { cardPopups } from '../../screens/Card/constants';
import CardGalileoBackSideView from '../../screens/Card/CardGalileoBackSideView';

const CardGalileoBackSideModal = ({ hide }) => {
  const [currentScreen, setCurrentScreen] = useState(cardPopups.CARD_GALILEO_BACK_SIDE);

  const cardFlow = useMemo(
    () => [
      {
        screen: cardPopups.CARD_GALILEO_BACK_SIDE,
        component: <CardGalileoBackSideView openScreen={setCurrentScreen} />,
      },
    ],
    []
  );

  const SelectedComponent = useMemo(
    () => cardFlow.find((item) => item.screen === currentScreen).component,
    [cardFlow, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal contentStyle={{ maxHeight: '33rem' }}>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

CardGalileoBackSideModal.propTypes = {
  hide: PropTypes.func.isRequired,
};

export default CardGalileoBackSideModal;
